import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNutshellRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "#FE5800",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.1 7.8a1 1 0 0 1-.7-.9l.5-2.9q-.1-.8-1.9-.7-1.8-.2-2 .7l.6 2.9a1 1 0 0 1-.8 1c-5.2.1-9 1.8-9 5V14l.6.6H15q.6 0 .6.6l-.5.5-7 1.4q-.5.1-.5.5v2.5a8.4 8.4 0 1 0 16.9.1v-5l.5-.6h1.6l.6-.6v-1.2c0-3.2-3.8-4.8-9-5" })
});
export default SvgNutshellRegularIcon;
